import logFunc from 'helpers/logFunc'
import isEmpty from 'lodash/isEmpty'
import reject from 'lodash/reject'
import take from 'lodash/take'
import {addElementToStackArray} from "../addElementToStackArray";

const TOKEN_KEY = '_wTokenKey'
const Coordinates_KEY = '_wCoordinatesKey'
const EXAM_PAPER_KEY = '_wExamPaperKey'
const LANGUAGE_KEY = '_wLanguage'
const CONTENT_LANGUAGE_KEY = '_wContentLanguage'
const PRIMARY_CATEGORY_KEY =
    '_wPrimaryCategory'
const GOD_WORD_DISPLAY_CONFIG_KEY = '_wGodWordDisplayConfigKey'
const DEBUG_MODE_KEY = '_wDebugModeKey'
const SCALE_FACTOR_KEY = '_wScaleFactorKey'

export function isDebugMode() {
    return !!Number(localStorage.getItem(DEBUG_MODE_KEY));
}

export function setDebug(value) {
    localStorage.setItem(DEBUG_MODE_KEY, value)
}

export function getScaleFactor() {
    return Number(localStorage.getItem(SCALE_FACTOR_KEY)) || 0;
}

export function setScaleFactor(value) {
    localStorage.setItem(SCALE_FACTOR_KEY, Number(value))
}

export function getStoredDefaultCountryId() {
    return localStorage.getItem("default_country_id_key") || 237;
}

export function setStoredDefaultCountryId(value) {
    localStorage.setItem("default_country_id_key", value)
}

export function getCoordinatesStore() {
    const coordinates = localStorage.getItem(Coordinates_KEY);
    if (!!!coordinates) return {};
    return JSON.parse(coordinates);
}

export function setCoordinatesStore(value) {
    localStorage.setItem(Coordinates_KEY,
        JSON.stringify({
            ...value,
            timestamp: Date.now(),
        })
    )
}

export function getGodWordDisplayConfigKey() {
    return localStorage.getItem(GOD_WORD_DISPLAY_CONFIG_KEY) || "0";
}

export function setGodWordDisplayConfigKey(value) {
    localStorage.setItem(GOD_WORD_DISPLAY_CONFIG_KEY, value)
}

export function getTokenKey() {
    return localStorage.getItem(TOKEN_KEY)
}

export const setTokenKey = (token) => {
    if (!token || token === 'null' || token === 'undefined') {
        // Không ghi null vào — giữ nguyên token cũ
        return;
    }
    localStorage.setItem(TOKEN_KEY, token);
};

export function clearTokenKey() {
    localStorage.removeItem(TOKEN_KEY)
}

export const saveLanguageKey = logFunc(
    language => {
        localStorage.setItem(
            LANGUAGE_KEY,
            language
        )
    }
)
export const saveContentLanguageKey = logFunc(
    language => {
        localStorage.setItem(
            CONTENT_LANGUAGE_KEY,
            language
        )
    }
)

export function getLanguageKey() {
    return localStorage.getItem(
        LANGUAGE_KEY
    )
}

export function getContentLanguageKey() {
    return localStorage.getItem(
        CONTENT_LANGUAGE_KEY
    ) || "vi"
}

export function setPrimaryCategory(
    cate_id
) {
    localStorage.setItem(
        PRIMARY_CATEGORY_KEY,
        cate_id
    )
}

export function getPrimaryCategory() {
    return localStorage.getItem(
        PRIMARY_CATEGORY_KEY
    )
}

export function getLocalExaminationPaperKey() {
    const items = localStorage.getItem(EXAM_PAPER_KEY) || "[]";
    let jsonItems = [];
    try {
        jsonItems = JSON.parse(items);
    } catch (e) {
    }
    return jsonItems.filter(e => !isEmpty(e));
}

export function setLocalExaminationPaperKey(item) {
    const items = localStorage.getItem(EXAM_PAPER_KEY) || "[]";
    let jsonItems = [];
    try {
        jsonItems = JSON.parse(items);
    } catch (e) {
    }
    jsonItems = jsonItems.filter(e => !isEmpty(e));

    jsonItems = reject(jsonItems, function (o) {
        return o.id === item.id;
    });
    jsonItems = [item, ...jsonItems];

    localStorage.setItem(EXAM_PAPER_KEY, JSON.stringify(jsonItems.slice(0, 10)))
}

export function removeLocalExaminationPaperKey(item) {
    const items = localStorage.getItem(EXAM_PAPER_KEY) || "[]";
    let jsonItems = [];
    try {
        jsonItems = JSON.parse(items);
    } catch (e) {
    }
    jsonItems = jsonItems.filter(e => !isEmpty(e));

    jsonItems = reject(jsonItems, function (o) {
        return o.id === item.id;
    });

    localStorage.setItem(EXAM_PAPER_KEY, JSON.stringify(jsonItems))
}


export function getFavorites(key, limit = 5) {
    const favorites = localStorage.getItem("FAVORITES") || "{}";
    let jsonFavorites = [];
    try {
        jsonFavorites = JSON.parse(favorites);
    } catch (e) {
        jsonFavorites = {}
    }

    return take(jsonFavorites[key] ?? [], 5)
}

export function addFavorite(key, item, limit = 5) {
    const favorites = localStorage.getItem("FAVORITES") || "{}";
    let jsonFavorites = [];
    try {
        jsonFavorites = JSON.parse(favorites);
    } catch (e) {
        jsonFavorites = {}
    }

    const items = jsonFavorites[key] ?? [];
    jsonFavorites[key] = addElementToStackArray(items, item, limit);

    localStorage.setItem("FAVORITES", JSON.stringify(jsonFavorites))
}


export const SESSION_TOKEN_KEY =
    'session_token'

export function setSessionToken(token) {
    sessionStorage.setItem(
        SESSION_TOKEN_KEY,
        token
    )
}

export function getSessionToken() {
    return sessionStorage.getItem(
        SESSION_TOKEN_KEY
    )
}

export function removeSessionToken() {
    sessionStorage.removeItem(
        SESSION_TOKEN_KEY
    )
}

const CLIENT_FINGERPRINT_KEY = '_wClientFingerprint'

const NEARBY_RADIUS_KEY = '_wNearbyRadiusKm'

export function getNearbyRadiusKm() {
    return Number(localStorage.getItem(NEARBY_RADIUS_KEY)) || 3
}

export function setNearbyRadiusKm(km) {
    localStorage.setItem(NEARBY_RADIUS_KEY, km)
}

export function getClientFingerprint() {
    let fp = sessionStorage.getItem(CLIENT_FINGERPRINT_KEY)
    if (!fp) {
        fp = (typeof crypto !== 'undefined' && crypto.randomUUID)
            ? crypto.randomUUID()
            : Math.random().toString(36).slice(2) + Date.now().toString(36)
        sessionStorage.setItem(CLIENT_FINGERPRINT_KEY, fp)
    }
    return fp
}